export default {
    en: {
        'main-heading': 'UNTERM USER GUIDE',
        'sub-heading-1': 'Searching for terms',
        'sub-heading-1-para-1': 'To search for terms, enter the text in the search box and click on <b>Search</b> or press <b>Enter</b>. Use the drop-down right menu to modify the <b>search type</b>, choosing from one of the following options:',
        'sub-heading-1-para-point-1': `</span><i><span>All words:</span></i><span> this is the default search option
                    and matches all words in your search against terminology entries. Results will
                    be returned when all words are found regardless of their order of occurrence.
                    For example, searching for “Rights Human” will return results for both “Rights
                    Human” and for “Human Rights”.
                </span>`,
        'sub-heading-1-para-point-2': `<i><span>Exact phrase:</span></i><span> this search option matches exactly the search query. For <span>
                        example,</span> &quot;human rights&quot; will find
                    human rights but not “rights human” nor “human right”.
                </span>`,
        'sub-heading-1-para-point-3': `<i>
                    <span>Fuzzy:</span></i><span> this search adds near matches to your
                    search results. For example, searching for '<span class=SpellE>dveelopment</span>'
                    will find 'development'.
                </span>`,
        'sub-heading-1-para-2': `<span>
                    Both <i>All words</i> and <i style='mso-bidi-font-style:normal'>Fuzzy </i>search also support the use of an asterisk, which replaces
                    any number of characters. For example:
                </span>`,
        'sub-heading-1-para-2-point-1': `<span>
                    Searching for “f*<span class=SpellE>th</span>” will find results for “fourth” or “fifth”.
                </span>`,
        'sub-heading-1-para-2-point-2': `<span>
                    Searching for “Task force on*”
                    will find results starting exactly with <i>Task force on</i>, followed by any text.
                </span>`,
        'para-1-img-alt': `search menu with search options`,
        'para-1-img-q-tip': `Quick tip: The shortcut Alt+s takes you back to the search box.`,
        'sub-heading-2': 'Using Advanced search',
        'sub-heading-2-para-1': 'The <i>Advanced search</i> option allows you to customize your search and narrow down results through the following menus:',
        'sub-heading-2-para-1-point-1': `<i>
                    <span>Search <span class=GramE>in<span style='font-style:normal'>:</span></span></span>
                </i><span>
                    this is the language of your search. The text you input in the search
                    will be used to search for similar text in the language/s chosen. All languages
                    are included by default.
                </span>`,
        'sub-heading-2-para-1-point-2': `<i>
                    <span>Display results <span class=GramE>in<span style='font-style:normal'>:</span></span></span>
                </i><span> these are the languages in which you will see results. </span>`,
        'sub-heading-2-para-1-point-3': `<i><span>Database</span></i><span>: these are the collections of records
                    from different entities where you can search. By default, all databases are
                    included in your search results.
                </span>`,
        'sub-heading-2-para-1-point-4': `<i><span>Body</span></i><span>: use this option to see results of
                    records that are related to specific bodies.<span>
                    </span>By default, all bodies are included in your search results.
                </span>`,
        'sub-heading-2-para-1-point-5': `<i><span>Subject</span></i><span>: use this option to see results of
                    records that are related to specific subjects.<span>
                    </span>By default, all subjects are included in your search results.
                </span>`,
        'sub-heading-2-para-2': `<span>
                    To
                    find a <i>Database</i>, <i style='mso-bidi-font-style: normal'>Body </i>or <i>Subject</i>, use the
                    drop-down menu to view the list or click on the menu and type the text you are
                    interested in. For example, typing “human” will display all subjects including
                    the text “human”. Select the ones you are interested in by checking the box
                    next to it. Once your selection is completed press Search.
                </span>`,
        'para-2-img-alt': `advanced menu displaying languages and dataset, subject and bodies drop down menus`,
        'sub-heading-3': 'Adjusting Settings',
        'sub-heading-3-para': `<span>
                    To set your search settings for future
                    sessions, go to the top of the page and click on <b style='mso-bidi-font-weight:normal'>Settings</b>. Under <b>Search in</b>,
                    check the boxes for your preferred search language. Under <b style='mso-bidi-font-weight:normal'>Display results in</b>, click all the languages in which you’d like to
                    get results. And under <b>Databases</b>,
                    pick the datasets you’d like to search. Once you have finished your selection,
                    click on <b>Update Default Settings</b> to
                    save your selection.
                </span>`,
        'para-3-img-alt': `settings tab options`,
        'sub-heading-4': ' Viewing and refining results',
        'sub-heading-4-para-1': `<span>
                    After launching the search, your term, the databases in which the term
                    was <span class=GramE>found</span> and the number of results will be displayed
                    at the top of the results. Click on <b>
                        Open
                    </b>to view the record in a separate tab or on <b style='mso-bidi-font-weight: normal'>Details </b>to view a summary of the record within the search results.
                </span>`,
        'para-4-img-alt': `search results display`,
        'para-4-footer-para-1': ` <span>
                    On the <span class=GramE>left hand</span> side of the results page, you
                    will find a <b>Filter </b>menu that allows
                    you to narrow down your results by <b>Database</b>,
                    <b>Body </b>or <b style='mso-bidi-font-weight:
normal'>Subject</b>. Click on the checkboxes to narrow down results and on
                    Clear all to return to the full results display. To close the filter, click on
                    the <b>X</b> at the top.
                </span>`,
        'para-4-img-alt-2': `open filter menu`,
        'sub-heading-5': ' Providing feedback and sharing record',
        'sub-heading-5-para-1': `<span>
                    To provide feedback on an existing record, whether to suggest a
                    modification or an addition, open the record and click on <b style='mso-bidi-font-weight:normal'>Send feedback</b>. A pop-up will open. Select the language for which
                    you’d like to provide feedback and fill out the fields, then click on <b>Submit</b>.
                </span>`,
        'sub-heading-5-img-alt': `Send feedback button in open record`,
        'sub-heading-5-footer-para-1': ` <span>
                    If your search returns no results, an envelope will be displayed at the
                    end of the page for you to submit a suggestion for a new record. A new tab will
                    open. Fill out the form and click on <b>Submit</b>.
                </span>`,
        'sub-heading-5-img-alt-2': `Link to record suggestion form`,
        'sub-heading-5-footer-para-2': `<span>
                    If you would like to share a record with someone, click on the <b>Share link </b><span>button,</span>
                    which will generate an email that includes the term and link to the record.
                </span>`,
        'sub-heading-5-img-alt-3': `Share link button in open record`,
        'sub-heading-5-img-alt-4': `Automatically generated email with link to record`,
        'sub-heading-6': 'Accessing resources',
        'sub-heading-6-para-1': `<span>
                    Under the <b>Resources </b>tab, you
                    will find the list of official <b>
                        country
                        names,
                    </b> together with an option to download the full list in a spreadsheet
                    format.
                </span>`,
        'sub-heading-7': 'Reporting technical issues',
        'sub-heading-7-para-1': `<span>
                    If you experience technical issues, go to <b>Help </b>and select <b>Contact Us</b>.
                    Fill out the form with details of the issue and click on <b>Submit</b>.
                </span>`,
        'sub-heading-7-img-alt': `Help menu with Contact Us submenu`,
        'one': 'I',
        'two': 'II',
        'three': 'III',
        'four': 'IV',
        'five': 'V',
        'six': 'VI',
        'seven': 'VII',
    },

    ar: {
        'main-heading': `UNTERM قاعدة مصطلحات الأمم المتحدة دليل المستخدم`,
        'sub-heading-1': 'البحث عن المصطلحات',
        'sub-heading-1-para-1': `<span>للبحث\nعن\nالمصطلحات،\nأدخِل النص في\nمربع البحث\nوانقر على <b>بحث</b>\nأو
  اضغط على\nزر<b> </b></span><b><span dir="LTR">Enter</span></b><span dir="RTL"></span><span><span dir="RTL"></span>.\nاستخدم\nالقائمة\nالمنسدلة إلى\nاليمين لتعديل\n<b>نوع البحث</b>،\nواختر واحدا\nمن الخيارات\nالتالية:</span>`,
        'sub-heading-1-para-point-1': `<span>البحث </span><span dir="LTR"></span
                                            ><span lang="EN" dir="LTR"><span dir="LTR"></span>”</span
                                            ><i><span>عن\nجميع الكلمات</span></i
                                            ><span dir="LTR"></span><span lang="EN" dir="LTR"><span dir="LTR"></span>“</span
                                            ><span dir="RTL"></span
                                            ><span
                                              ><span dir="RTL"></span>:\nهو خيار البحث\nالمطبّق\nتلقائيا ويتم\nفي
                                              إطاره\nالتفتيش ضمن المدخلات\nالمصطلحية عن
                                              <span >&nbsp;</span>كل كلمة\nتُدخَل في\nمربع
                                              البحث.\nوتظهر النتائج\nعند العثور\nعلى جميع\nالكلمات بغض\nالنظر عن\nترتيبها.
                                              فعلى\nسبيل المثال،\nعند البحث عن<span
                                                >&nbsp;
                                              </span></span
                                            ><span dir="LTR"></span
                                            ><span lang="EN" dir="LTR"><span dir="LTR"></span>“Human Rights”</span
                                            ><span dir="RTL"></span
                                            ><span><span dir="RTL"></span>،\nتظهر نتائج\nلكل من </span
                                            ><span dir="LTR"></span
                                            ><span lang="EN" dir="LTR"><span dir="LTR"></span>“Rights Human”</span
                                            ><span dir="RTL"></span><span><span dir="RTL"></span> و </span
                                            ><span dir="LTR"></span
                                            ><span lang="EN" dir="LTR"><span dir="LTR"></span>“Human Rights”</span
                                            ><span dir="RTL"></span><span><span dir="RTL"></span>.</span
                                            ><span dir="LTR"></span>
                                            `,
        'sub-heading-1-para-point-2': `<span>البحث </span><span dir="LTR"></span
                                    ><span lang="EN" dir="LTR"><span dir="LTR"></span>”</span
                                    ><i><span>عن\nعبارة محددة</span></i
                                    ><span dir="LTR"></span><span lang="EN" dir="LTR"><span dir="LTR"></span>“</span
                                    ><span dir="RTL"></span
                                    ><span
                                      ><span dir="RTL"></span>:\nيتم في إطار\nهذا الخيار\nالبحثي\nالتفتيش عن\nعبارة
                                      محددة.\nفعلى سبيل\nالمثال، عند\nالبحث عن </span
                                    ><span dir="LTR"></span
                                    ><span dir="LTR"><span dir="LTR"></span>“human rights”</span
                                    ><span dir="RTL"></span><span><span dir="RTL"></span>،\nتظهر نتائج\nتتضمن </span
                                    ><span dir="LTR"></span
                                    ><span dir="LTR"><span dir="LTR"></span>“human rights”</span
                                    ><span dir="RTL"></span><span><span dir="RTL"></span>،\nلا </span
                                    ><span dir="LTR"></span
                                    ><span lang="EN" dir="LTR"><span dir="LTR"></span>“rights\nhuman”</span
                                    ><span dir="RTL"></span><span><span dir="RTL"></span> أو </span
                                    ><span dir="LTR"></span
                                    ><span lang="EN" dir="LTR"><span dir="LTR"></span>“human right”</span
                                    ><span dir="RTL"></span><span><span dir="RTL"></span>.</span>
                                    `,
        'sub-heading-1-para-point-3': `<i><span lang="AR-SA"><span dir="RTL"></span>”بحث\nتقريبي“</span></i
                        ><span lang="AR-SA"
                          >: يضيف\nهذا البحث\nنتائج\nتقريبية إلى\nحصيلة النتائج.\nفعلى سبيل\nالمثال،
                          إذا\nبحثت عن كلمة </span
                        ><span dir="LTR"></span
                        ><span lang="EN" dir="LTR"
                          ><span dir="LTR"></span>“<span class="SpellE">dveelopment</span>”</span
                        ><span dir="RTL"></span
                        ><span lang="AR-SA"><span dir="RTL"></span>،\nستتضمن\nالنتائج كلمة </span
                        ><span dir="LTR"></span
                        ><span lang="EN" dir="LTR"><span dir="LTR"></span>“development”</span
                        ><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span>
                        `,
        'sub-heading-1-para-2': `<span>وعند استخدام أي من خياري البحث <i>عن كل الكلمات </i>أو <i>البحث التقريبي</i>،
                          يمكن استخدام النجمة (*)، التي تحل محل أي عدد من الأحرف أو الرموز. فعلى سبيل
                          المثال:</span>
                        `,
        'sub-heading-1-para-2-point-1': `<span lang="AR-SA">يُظهر\nالبحث عن كلمة\n</span><span dir="LTR"></span
                        ><span lang="EN" dir="LTR"><span dir="LTR"></span>“</span
                        ><span lang="EN" dir="LTR">f*<span class="SpellE">th</span></span
                        ><span lang="EN" dir="LTR">”</span><span dir="RTL"></span
                        ><span lang="AR-SA"><span dir="RTL"></span>\nنتائج تتضمن\nكلمة </span
                        ><span dir="LTR"></span
                        ><span lang="EN" dir="LTR"><span dir="LTR"></span>“fourth”</span
                        ><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>\nأو </span
                        ><span dir="LTR"></span
                        ><span lang="EN" dir="LTR"><span dir="LTR"></span>“fifth”</span
                        ><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>.</span>
                        `,
        'sub-heading-1-para-2-point-2': `<span lang="AR-SA">ويُظهر\nالبحث عن\nعبارة </span><span dir="LTR"></span
                                        ><span lang="EN" dir="LTR"><span dir="LTR"></span>“Task force on*”</span
                                        ><span lang="AR-SA">نتائج\nتبدأ تحديدا\nبـ </span
                                        ><span lang="EN" dir="LTR">Task force on</span><span dir="RTL"></span
                                        ><span lang="AR-SA"><span dir="RTL"></span>،\nيليها أي نص.</span>`,
        'para-1-img-alt': `قائمة البحث مع خيارات البحث`,
        'para-1-img-q-tip': `نصيحة سريعة: هناك طريقة مختصرة للعودة إلى مربع البحث، عبر الضغط على  Alt+s.`,
        'sub-heading-2': 'استخدام البحث المتقدم',
        'sub-heading-2-para-1': `يتيح لك خيار البحث المتقدم تخصيص البحث وتضييق نطاق النتائج من خلال القوائم
التالية:
`,
        'sub-heading-2-para-1-point-1': `<i><span>لغة البحث</span></i><span>
                                  : تشير إلى اللغة التي تستخدمها للبحث. وما تدخله في مربع البحث يتم استخدامه
                                  للبحث عن نص مماثل باللغة أو اللغات المختارة. وإذا لم تختر أي لغة، يكون تفعيل
                                  جميع اللغات هو الوضع المطبق تلقائيا.
                                </span>`,
        'sub-heading-2-para-1-point-2': `<i><span>عرض النتائج باللغة</span></i>
                                        <span>: هي اللغة أو اللغات التي ترى بها النتائج. </span>`,
        'sub-heading-2-para-1-point-3': `<i><span>قاعدة البيانات</span></i><span>: يُستخدم هذا الخيار لعرض نتائج البطاقات المرتبطة بمواضيع معينة. والوضع
                                          المطبق تلقائيا هو أن تشمل نتائج البحث جميع المواضيع.</span>`,
        'sub-heading-2-para-1-point-4': `<i><span>الهيئات</span></i>
                                            <span
                                              >: يُستخدم هذا الخيار لعرض نتائج البطاقات المرتبطة بهيئات معينة. والوضع المطبق
                                              تلقائيا هو أن تشمل نتائج البحث جميع الهيئات.</span>
                                            `,
        'sub-heading-2-para-1-point-5': `<i><span>المواضيع</span></i>
                                    <span>: يُستخدم هذا الخيار لعرض نتائج البطاقات المرتبطة بمواضيع معينة. والوضع
                                      المطبق تلقائيا هو أن تشمل نتائج البحث جميع المواضيع.</span>
                                    `,
        'sub-heading-2-para-2': `<span lang="AR-SA">وللعثور\nعلى <i>قاعدة\nبيانات</i> أو <i>هيئة</i>\nأو
                                  <i>موضوع</i>،\nاستخدم\nالقائمة\nالمنسدلة\nلعرض الخيارات\nأو انقر
                                  على\nالقائمة\nواكتب النص\nالذي تودّ البحث\nعنه. فعلى\nسبيل المثال،\nعندما
                                  تكتب\nكلمة </span
                                ><span dir="LTR"></span><span lang="EN" dir="LTR"><span dir="LTR"></span>“</span
                                ><span dir="LTR">human</span><span lang="EN" dir="LTR">”</span
                                ><span dir="RTL"></span><span lang="AR-SA"><span dir="RTL"></span>\nت</span
                                ><span lang="AR-SA">ظ</span
                                ><span lang="AR-SA">هر\nجميع\nالمواضيع\nالتي تتضمن\nكلمة </span
                                ><span dir="LTR"></span><span lang="EN" dir="LTR"><span dir="LTR"></span>“</span
                                ><span dir="LTR">human</span><span lang="EN" dir="LTR">”</span
                                ><span dir="RTL"></span
                                ><span lang="AR-SA"
                                  ><span dir="RTL"></span>.\nاختر\nالمواضيع\nالتي تهمّك بوضع\nعلامة
                                  في\nالمربع\nالمجاور لها.\nوعندما تكتمل\nجميع عناصر\nاختيارك،\nانقر على
                                  <b>بحث</b>.</span>`,
        'sub-heading-3': 'ضبط الإعدادات',
        'sub-heading-3-para': `<span lang="AR-SA">
                              لتحديد إعدادات البحث بهدف حفظها عند استخدام بوابة المصطلحات في المستقبل، انقر
                              على <b>الإعدادات </b>في أعلى الصفحة<b>.</b> وتحت <b>لغة البحث</b>، ضع علامة في
                              المربعات الخاصة بلغة أو لغات البحث المفضلة لديك. وتحت
                              <b>عرض النتائج باللغة</b>، انقر على جميع اللغات التي تريد عرض النتائج بها.
                              وتحت <b>قواعد بيانات</b>، اختر مجموعات البيانات التي تود البحث فيها. وعند
                              الانتهاء من تحديد عناصر خيارك، انقر على
                              <b>تحديث الإعدادات المفترضة تلقائيا</b> لحفظ خيارك.</span>`,
        'sub-heading-4': 'عرض النتائج وتنقيتها',
        'sub-heading-4-para-1': `<span lang="AR-SA"
                              >بعد بدء البحث، يُعرض المصطلح الذي بحثتَ عنه، وقواعد البيانات التي عُثر فيها
                              على المصطلح، وعدد النتائج، وذلك فوق النتائج التي تظهر. انقر على
                              <b>فتح البطاقة</b> لعرض البطاقة ضمن علامة تبويب منفصلة أو على<b> التفاصيل</b>
                              لعرض ملخص للبطاقة ضمن نتائج البحث.
                            </span>
                            `,
        'para-4-footer-para-1': `<span lang="AR-SA"
                              >على الجانب الأيسر من صفحة النتائج، ستجد قائمة<b> </b>لتنقية النتائج<b>
                                (”منقّي“) </b
                              >تتيح لك تضييق نطاق النتائج حسب قاعدة البيانات أو الهيئة أو الموضوع. انقر على
                              خانات الاختيار لتضييق نطاق النتائج وعلى<b> محو جميع الحقول</b> للعودة إلى عرض
                              النتائج الكاملة. ولإغلاق المنقّي، انقر على علامة
                            </span>`,
        'sub-heading-5': 'تقديم الملاحظات ومشاركة البطاقة',
        'sub-heading-5-para-1': `<span lang="AR-SA"
                                  >لتقديم ملاحظات على بطاقة موجودة، سواء لاقتراح تعديل أو إضافة، افتح البطاقة
                                  وانقر على إ<b>رسال ملاحظاتكم</b>. عندها، ستُفتح نافذة منبثقة. حدد اللغة التي
                                  ترغب في تقديم ملاحظات بشأنها واملأ الحقول، ثم انقر على<b> إرسال</b>.</span>
                                `,
        'sub-heading-5-footer-para-1': `<span  lang="AR-SA">إذا لم يؤدّ بحثك إلى أي نتائج، سيظهر شكل مظروف في نهاية الصفحة تستخدمه إذا
                                          أردتَ إرسال اقتراح لإنشاء بطاقة جديدة. عندها ستُفتح علامة تبويب جديدة. املأ
                                          النموذج وانقر على <b>إرسال</b>.</span>
                                        `,
        'sub-heading-5-footer-para-2': `<span lang="AR-SA">إذا كنت ترغب في مشاركة إحدى البطاقات مع شخص ما، انقر على زر
                                          <b>مشاركة الرابط، </b>وعندها<b> </b>سيتم إعداد رسالة بالبريد الإلكتروني تتضمن
                                          المصطلح ورابطا يحيل إلى البطاقة.</span>
                                        `,
        'sub-heading-6': 'الوصول إلى الموارد',
        'sub-heading-6-para-1': `<span lang="AR-SA">تحت علامة التبويب المعنونة <b>الموارد</b>، تجد قائمة
                              <b>بأسماء البلدان</b> الرسمية، إلى جانب خيار لتنزيل القائمة الكاملة على شكل
                              جدول بيانات.</span>
                            `,
        'sub-heading-7': 'الإبلاغ عن المشاكل التقنية',
        'sub-heading-7-para-1': `<span lang="AR-SA">إذا واجهتَ مشاكل تقنية، انقر على <b>المساعدة</b> واختر <b>اتصل بنا</b>.
                                  أَدخِل تفاصيل المشكلة في النموذج وانقر على<b> إرسال</b>.</span>
                                `,
        'one': 'أولا',
        'two': 'ثانيا',
        'three': 'ثالثا',
        'four': 'رابعا',
        'five': 'خامسا',
        'six': 'سادسا',
        'seven': 'سابعا',
    },

    es: {
        'main-heading': 'Guía de uso de UNTERM',
        'sub-heading-1': 'Buscar términos',
        'sub-heading-1-para-1': `<span>Para buscar un término, escríbalo en el cuadro de
            búsqueda y haga clic en <b>Buscar </b>o presione la tecla <b>Entrar</b>. En el menú desplegable derecho, elija una de estas
            opciones de <b style="mso-bidi-font-weight:normal">tipo de búsqueda</b>:</span>`,

        'sub-heading-1-para-point-1': `<i><span>Todas las palabras.</span></i>
                <span > Es la opción predeterminada y busca entradas
                terminológicas que contengan todas las palabras consultadas, en cualquier orden.
                Por ejemplo, si busca “<span class="SpellE">Rights</span> Human”, obtendrá
                resultados para “<span class="SpellE">Rights</span> Human” y “Human <span class="SpellE">Rights</span>”.</span>`,

        'sub-heading-1-para-point-2': `<i>
                <span>Frase exacta. </span>
            </i><span>Con esta opción
                se buscan coincidencias exactas del texto consultado. Por ejemplo, si busca “human
                <span class=SpellE>rights</span>”, encontrará “human <span class=SpellE>rights</span>”,
                pero no “<span class=SpellE>rights</span> human” ni “human <span class=SpellE>right</span>”.
            </span>`,

        'sub-heading-1-para-point-3': `<i><span>Búsqueda aproximada.</span></i><span> Esta búsqueda
                ofrece también coincidencias aproximadas en los resultados. Por ejemplo, si
                busca “<span class=SpellE>dveelopment</span>”, encontrará “<span class=SpellE>development</span>”.
            </span>`,
        'sub-heading-1-para-2': `<span>Las opciones <i>Todas las palabras</i> y <i>Búsqueda aproximada </i>admiten
                también el uso del asterisco, que reemplaza uno o varios caracteres. Por
                ejemplo:
            </span>`,
        'sub-heading-1-para-2-point-1': `<span>
                Si busca “f*<span class=SpellE>th</span>”, verá resultados para “<span class=SpellE>fourth</span>” y “<span class=SpellE>fifth</span>”.
            </span>`,
        'sub-heading-1-para-2-point-2': `<span>La búsqueda “<span >Task</span> <span >force</span> <span >on</span>*” arrojará resultados que comienzan literalmente con las
                palabras <span ><i>Task force on</i></span>, seguidas de cualquier otro texto.
            </span>`,

        'para-1-img-alt': `Menú de búsqueda y opciones`,
        'para-1-img-q-tip': `Sugerencia: Para volver al cuadro de búsqueda, use la combinación de teclas Alt + S.`,
        'sub-heading-2': 'Usar la búsqueda avanzada',
        'sub-heading-2-para-1': `<span>
                Con la opción <i>
                    Búsqueda avanzada
                </i> puede personalizar la búsqueda y restringir los resultados mediante
                los menús siguientes:
            </span>`,

        'sub-heading-2-para-1-point-1': `<i><span>Buscar en.</span></i><span>
                 Se trata del idioma
                en que se hace la búsqueda. Se usará el texto que escriba para buscar texto parecido
                en el idioma o los idiomas seleccionados. De manera predeterminada, se incluyen
                todos los idiomas.
            </span>`,
        'sub-heading-2-para-1-point-2': `<i><span>Mostrar resultados en.</span></i><span>
                 Son los idiomas en que verá los resultados.
            </span>`,
        'sub-heading-2-para-1-point-3': `<i><span>Conjuntos de datos.</span></i><span>
                 Son las
                colecciones de fichas de diferentes entidades en las que se pueden hacer búsquedas,
                y están todas incluidas de manera predeterminada.
            </span>`,
        'sub-heading-2-para-1-point-4': `<i>
                <span>
                    Campo
                    temático.
                </span>
            </i><span>
                 Con esta opción
                se pueden ver en los resultados las fichas relacionadas con campos temáticos concretos
                (están todos incluidos de manera predeterminada).
            </span>`,
        'sub-heading-2-para-1-point-5': `<i><span>Órgano.</span></i><span>
                 Con esta opción se pueden ver en los
                resultados las fichas relacionadas con órganos concretos (están todos incluidos
                de manera predeterminada).
            </span>`,
        'sub-heading-2-para-2': `<span>
                Para elegir <i>conjuntos de datos</i>, <i>campos temáticos</i> u <i>órganos</i>,
                despliegue la lista del menú correspondiente o haga clic en el menú y escriba
                el texto que le interese. Por ejemplo, si escribe “humano”, se mostrarán todos
                los campos temáticos que incluyan la palabra “humano”. Seleccione las casillas de
                los que desee y presione <b>Buscar</b>.
            </span>`,
        'para-2-img-alt': `Menú avanzado con los idiomas y los menús desplegables de conjuntos de datos, campos temáticos y órganos`,
        'sub-heading-3': 'Ajustar la configuración',
        'sub-heading-3-para': `<span>
                Para
                definir la configuración de búsqueda para sesiones posteriores, en la parte
                superior de la página haga clic en <b >Configuración</b>.
                En <b >Buscar en</b>, active las casillas de
                los idiomas de búsqueda que prefiera. En <b >Mostrar resultados en</b>, haga clic en todos los idiomas en que desee obtener
                resultados. Por último, en <b >Bases de datos</b>, elija los conjuntos de datos en que desee realizar búsquedas. Una
                vez finalizada la selección, haga clic en <b >
                    Actualizar
                    configuración predeterminada
                </b> para guardarla.
            </span>`,
        'para-3-img-alt': `Opciones de la pestaña Configuración`,
        'sub-heading-4': 'Ver y filtrar los resultados',
        'sub-heading-4-para-1': `<span>
                Una vez hecha la búsqueda, verá sobre los
                resultados los conjuntos de datos donde se encontró el término y el número de coincidencias.
                Haga clic en <b >Abrir </b>para ver la ficha
                en otra pestaña o en <b >Detalles </b>para
                ver un resumen de la ficha integrado en los resultados de la búsqueda.
            </span>`,
        'para-4-img-alt': `Pantalla de resultados de la`,
        'para-4-footer-para-1': `<span>
                En la parte izquierda de la página de resultados
                encontrará el menú <b >Filtrar</b><span >, en el que puede </span>restringir los
                resultados en función de la <b >base de datos</b>, el <b >órgano </b>o el <b >campo temático</b>. Active las casillas que
                le interesen para restringir los resultados y haga clic en <b>Borrar todo</b> para
                volver a verlos todos. Para cerrar el filtro, haga clic en la <b >X</b> de la parte superior.
            </span>`,
        'para-4-img-alt-2': `Menú Filtrar abierto`,
        'sub-heading-5': 'Enviar comentarios y compartir fichas',
        'sub-heading-5-para-1': `<span>
                Para enviar comentarios sobre una ficha
                existente, a fin de sugerir que se cambie o añada algo, ábrala y haga clic en <b >Enviar un comentario</b>. Aparecerá una
                ventana: seleccione el idioma al que se refiere su comentario, rellene los
                campos y haga clic en <b >Enviar</b>.
            </span>`,
        'sub-heading-5-img-alt': `Botón Enviar un comentario en una ficha abierta`,
        'sub-heading-5-footer-para-1': ` <span>
                Si la búsqueda no arroja ningún resultado,
                al final de la página aparecerá un icono en forma de sobre con el que puede sugerir
                una nueva ficha. En la pestaña que se abre, rellene el formulario y haga clic
                en <b >Enviar</b>.
            </span>`,
        'sub-heading-5-img-alt-2': `Enlace al formulario para sugerir una ficha`,
        'sub-heading-5-footer-para-2': ` <span>
                Si desea compartir una ficha con otra
                persona, haga clic en el botón <b >
                    Enviar esta
                    ficha por correo electrónico
                </b> y se generará un mensaje en el que figurarán
                el término y un enlace a la ficha.
            </span>`,
        'sub-heading-5-img-alt-3': `Botón Enviar esta ficha por correo electrónico en una ficha abierta`,
        'sub-heading-5-img-alt-4': `Correo electrónico generado automáticamente con un enlace a la ficha`,
        'sub-heading-6': 'Acceder a los recursos',
        'sub-heading-6-para-1': `<span>
                En la pestaña <b
>Recursos</b> encontrará la lista oficial de <b
>nombre de países</b><span >,</span> junto
                con una opción para descargar la lista completa en formato de hoja de cálculo.
            </span>`,
        'sub-heading-7': 'Notificar problemas técnicos',
        'sub-heading-7-para-1': `<span>
                Si tiene problemas técnicos, vaya a <b >Ayuda </b>y seleccione <b
>Contacto</b>. Rellene el formulario con información detallada sobre el
                problema y haga clic en <b >Enviar</b>.
            </span>`,
        'sub-heading-7-img-alt': `Menú Ayuda con submenú Contacto`,
        'one': 'I',
        'two': 'II',
        'three': 'III',
        'four': 'IV',
        'five': 'V',
        'six': 'VI',
        'seven': 'VII',
    },

    fr: {
        'main-heading': 'Manuel d’utilisation d’UNTERM',
        'sub-heading-1': 'Rechercher un terme',
        'sub-heading-1-para-1': 'Pour effectuer une recherche, saisissez le terme voulu dans le champ de recherche. Cliquez sur <b>Rechercher</b> ou appuyez sur <b>Entrée</b> après avoir sélectionné l’une des options ci-dessous dans le menu déroulant situé à droite :',
        'sub-heading-1-para-point-1': `<i><span>Tous les mots :</span></i>
                                    <span> cette option, sélectionnée par défaut, permet de rechercher les entrées terminologiques qui
                                        comprennent tous les mots saisis dans le champ de recherche. Sont données en
                                        résultat les fiches qui contiennent tous les mots recherchés, même si ceux-ci
                                        n’apparaissent pas dans le même ordre. Par exemple, si l’on saisit « <span>Rights</span> Human&nbsp;», les résultats feront apparaître les
                                        fiches comportant les mots «&nbsp;<span>Rights</span> Human&nbsp;»
                                        et «&nbsp;Human <span>Rights</span>&nbsp;».</span>`,
        'sub-heading-1-para-point-2': `<i><span>Expression exacte :</span></i>
                                    <span> cette option
                                        permet de rechercher les entrées qui correspondent mot pour mot à l’expression
                                        saisie dans le champ de recherche. Par exemple, si l’on saisit «&nbsp;<span >human</span> <span >rights</span>&nbsp;», on trouvera
                                        l’entrée «&nbsp;<span >human</span> <span >rights</span>&nbsp;»,
                                        mais pas les entrées comprenant «&nbsp;<span >rights</span> <span >human</span>&nbsp;» ou «&nbsp;<span >human</span>
                                        right&nbsp;».</span>`,
        'sub-heading-1-para-point-3': `<i><span>Correspondance partielle :</span></i>
    <span > cette option
        permet de faire remonter également les entrées dont le libellé se rapproche du
        terme recherché. Par exemple, si l’on saisit «&nbsp;<span >dveelopment</span>&nbsp;»,
        on trouvera également les entrées comportant «&nbsp;<span >development</span>&nbsp;».</span>`,
        'sub-heading-1-para-2': `Il est également possible d’utiliser l’astérisque, qui sert à remplacer un ou plusieurs caractères, avec les modes recherche par « Tous les mots » ou par « Correspondance partielle ». Par exemple :`,
        'sub-heading-1-para-2-point-1': `En recherchant « f*th », les résultats feront ressortir « fourth » et « fifth ».`,
        'sub-heading-1-para-2-point-2': `En recherchant  « Task force on* », les résultats feront ressortir toutes les fiches correspondant aux termes qui commencent exactement par « Task force on ».`,
        'para-1-img-alt': `Menu et options de recherche`,
        'para-1-img-q-tip': `Astuce: Le raccourci clavier Alt+s permet de regagner le champ « recherche »`,
        'sub-heading-2': 'Recherche avancée',
        'sub-heading-2-para-1': '<span>La <i>Recherche avancée</i> permet de personnaliser les options de recherche et de filtrer les résultats&nbsp;:</span>',
        'sub-heading-2-para-1-point-1': `<i><span>Rechercher en :</span></i><span> permet de
                sélectionner les langues dans lesquelles la recherche est effectuée. Le texte
                saisi dans le champ de recherche est recherché dans la ou les langues
                sélectionnées. Toutes les langues sont sélectionnées par défaut.</span>`,
        'sub-heading-2-para-1-point-2': `<i><span>Afficher les résultats en : </span></i>
                                        <span> permet de sélectionner les langues dans lesquelles les résultats s’affichent.</span>`,
        'sub-heading-2-para-1-point-3': `<i><span>Base de données :</span></i><span> permet de
                                        cibler les recherches en sélectionnant la base de données des entités qui vous
                                        intéressent. Toutes les bases de données sont sélectionnées par défaut.</span>`,
        'sub-heading-2-para-1-point-4': `<i><span>Organes :</span></i>
                            <span>permet de faire remonter les fiches relatives à tel ou tel organe.<span>&nbsp; </span>Tous les organes sont sélectionnés par défaut.</span>`,
        'sub-heading-2-para-1-point-5': `<i><span>Domaines :</span></i>
                                        <span> permet de faire remonter les fiches
                                            relevant de tel ou tel domaine.<span>&nbsp; </span>Tous les
                                            domaines sont sélectionnés par défaut.</span>`,
        'sub-heading-2-para-2': `<span>Pour trouver la <i>Base de données, </i>l’<i>Organe</i>
                                ou le <i>Domaine </i>qui vous intéresse, vous pouvez soit utiliser le menu déroulant
                                pour faire défiler la liste, soit <span>faire</span> une recherche
                                par mot-clé. Par exemple, en saisissant « <span>human</span> »,
                                tous les domaines dont le libellé comporte ce mot s’afficheront. Cochez ensuite
                                vos préférences, puis appuyez sur <i>Recherche.</i></span>`,
        'para-2-img-alt': `advanced menu displaying languages and dataset, subject and bodies drop down menus`,
        'sub-heading-3': 'Paramétrage',
        'sub-heading-3-para': `<span>Pour paramétrer vos futures recherches, cliquez
                                sur <b>Paramètres</b> en haut de la page. Sous <b>Rechercher en</b>,
                                sélectionnez les langues de recherche de votre choix. Sous <b>Afficher les
                                résultats en</b>, sélectionnez les langues dans lesquelles vous souhaitez voir
                                apparaître les résultats. Sous <b>Bases de données</b>, sélectionnez les
                                ensembles de données dans lesquels vous souhaitez effectuer vos recherches.
                                Cliquez ensuite sur <b>Modifier les paramètres par défaut </b>pour enregistrer
                                vos préférences.</span>`,
        'para-3-img-alt': `Options de paramétrage`,
        'sub-heading-4': 'Affichage et filtrage des résultats',
        'sub-heading-4-para-1': `<span>Après avoir lancé votre recherche, le
                                    terme recherché, les bases de données dans lesquelles le terme a été trouvé et
                                    le nombre de résultats trouvés sont affichés en haut de la page de résultats.
                                    Cliquez sur <b>Ouvrir<i> </i></b>pour ouvrir la fiche dans un onglet distinct
                                    ou sur <b>Description</b> pour afficher un résumé de la fiche directement dans
                                    la page de résultats.</span>`,
        'para-4-img-alt': `Affichage des résultats`,
        'para-4-footer-para-1': `<span>Situé à gauche de la page de résultats, le
                            menu <b>Filtre </b>vous permet de filtrer les résultats par <b>Bases de données</b>,
                            <b>Organes</b> ou <b>Domaines</b>. Filtrez les résultats selon vos préférences en
                            cochant les cases correspondantes. Pour supprimer tous les filtres, cliquez sur
                            Tout effacer. Pour fermer le menu, cliquez sur la croix (X) située en haut à
                            droite de la fenêtre.</span>`,
        'para-4-img-alt-2': `ouvrir le menu filtre`,
        'sub-heading-5': 'Envoyer un commentaire et partager la fiche',
        'sub-heading-5-para-1': `<span>Pour envoyer un commentaire au sujet d’une
                                fiche existante, que ce soit pour en demander la modification ou pour proposer
                                de la compléter, ouvrez la fiche en question et cliquez sur <b>Envoyer un commentaire</b>.
                                Dans la boîte de dialogue qui s’ouvre, sélectionnez la langue sur laquelle
                                porte votre commentaire et remplissez les champs requis, puis cliquez sur <b>Envoyer</b>.</span>`,
        'sub-heading-5-img-alt': `Bouton Envoyer un commentaire dans une fiche ouverte`,
        'sub-heading-5-footer-para-1': `<span >Si votre recherche ne donne <span >aucun résultat</span>, vous êtes invité à envoyer une suggestion
                                        en cliquant sur l’enveloppe qui s’affiche. Un nouvel onglet s’ouvre alors.
                                        Remplissez les champs prévus à cet effet, puis cliquez sur <b>Envoyer.</b></span>`,
        'sub-heading-5-img-alt-2': `Lien vers le formulaire de proposition de fiche`,
        'sub-heading-5-footer-para-2': `<span>Si vous souhaitez faire suivre une fiche à
                                        quelqu’un, cliquez sur le bouton <b>Partager un lien vers cette fiche par
                                        courriel</b>. Un courriel contenant le terme et le lien vers la fiche sera
                                        alors généré.</span>`,
        'sub-heading-5-img-alt-3': `Bouton Partager un lien dans la fiche ouverte`,
        'sub-heading-5-img-alt-4': `courriel généré automatiquement et contenant un lien vers la fiche`,
        'sub-heading-6': 'Accès aux ressources',
        'sub-heading-6-para-1': `<span>Sous la rubrique <b>Ressources</b>, vous
                                trouverez la liste des noms de pays officiels, qu’il est possible de
                                télécharger en intégralité sous la forme d’un fichier de type tableur.</span>`,
        'sub-heading-7': 'Signaler un problème technique',
        'sub-heading-7-para-1': `<span>Si vous rencontrez un problème technique,
                                cliquez sur <b>Contact</b> sous la rubrique <b>Aide</b>. Décrivez le problème
                                rencontré dans le formulaire prévu à cet effet, puis cliquez sur <b>Envoyer.</b></span>`,
        'sub-heading-7-img-alt': `Menu Aide, sous-menu Contact`,
        'one': 'I',
        'two': 'II',
        'three': 'III',
        'four': 'IV',
        'five': 'V',
        'six': 'VI',
        'seven': 'VII',
    },

    ru: {
        'main-heading': 'Руководство пользователя ЮНТЕРМ',
        'sub-heading-1': 'Поиск терминов',
        'sub-heading-1-para-1': '<span ></span>Для\nпоиска\nтерминов\nвведите\nтекст в поле\nпоиска и\nнажмите текстовую\nкнопку <b>Поиск</b>\nили клавиатурную\nклавишу </span><b><span >Enter</span></b><span > <b><span >(Ввод)</span></b><span >.\nИспользуйте\nвыпадающее\nправое меню для\nизменения\nтипа поиска,\nвыбрав одну\nиз следующих\nопций:</span></span>',
        'sub-heading-1-para-point-1': `<i><span>Все слова</span></i><span>: это вариант поиска по умолчанию, который сопоставляет все слова в вашем
              поиске с терминологическими записями — «карточками». Результаты будут
              содержать все найденные слова, независимо от их окончаний и порядка. Например,
              при поисковом запросе «развитие права» будут получены результаты как для
              «права на развитие», так и для «развитие прав».</span>`,
        'sub-heading-1-para-point-2': `<i><span>Точное словосочетание</span></i><span>: при выборе этой опции результаты поиска будут точно соответствовать
                  поисковому запросу. Например, при поисковом запросе «права на развитие» будут
                  показаны соответствия «права на развитие», но не «развитие права».</span>
                `,
        'sub-heading-1-para-point-3': `<i><span>Неполные совпадения</span></i><span>: этот поиск добавляет к результатам поиска неполные совпадения. Например,
                    при поиске «рзвитие» будет найдено «развитие».</span>`,
        'sub-heading-1-para-2': `<span>При поиске по всем словам и при поиске с неполным совпадением также
                  поддерживается использование звездочки, которая заменяет любое количество
                  символов. Например:</span
                >
                `,
        'sub-heading-1-para-2-point-1': `при поиске «*тьдесят» будут найдены результаты как с «пятьдесят», так и с «шестьдесят».`,
        'sub-heading-1-para-2-point-2': `При поиске «Целевая группа по *» будут найдены результаты, начинающиеся с фразы «Целевая группа по», за которой следует любой текст.`,
        'para-1-img-alt': `меню поиска с параметрами поиска`,
        'para-1-img-q-tip': `Совет: вернуться в строку поиска можно при помощи комбинации клавиш Alt+s.`,
        'sub-heading-2': 'Использование расширенного поиска',
        'sub-heading-2-para-1': `<span>Опция <i>Расширенный поиск</i> позволяет настроить поиск и сузить результаты
                                  с помощью следующих разделов меню:</span>`,
        'sub-heading-2-para-1-point-1': `<span>Языки поиска:</span>
                                        <span> языки поискового запроса. Текст, который вы вводите в поисковое окно, будет
                                          использоваться для поиска аналогичного текста на выбранных языках. По
                                          умолчанию поиск осуществляется по всем языкам.</span>
                                        `,
        'sub-heading-2-para-1-point-2': `Языки результата: языки, на которых вы будете видеть результаты.`,
        'sub-heading-2-para-1-point-3': `Раздел данных: коллекция карточек от различных структур, по которой можно вести поиск. По умолчанию результаты поиска содержат карточки из любых разделов данных.`,
        'sub-heading-2-para-1-point-4': `Орган: используйте эту опцию для фильтрации результатов по определенному органу. По умолчанию результаты поиска содержат карточки, касающиеся любых органов.`,
        'sub-heading-2-para-1-point-5': `Тематика: используйте эту опцию для фильтрации результатов по определенной тематике. По умолчанию результаты поиска содержат карточки, относящиеся к любой тематике.`,
        'sub-heading-2-para-2': `<span>Чтобы выбрать раздел данных, орган или тематику, используйте выпадающее меню
                                  для просмотра списка или щелкните по меню и введите интересующий вас текст.
                                  Например, если ввести «право», то будут показаны все тематики, в названии
                                  которых содержится слово «право». Выберите интересующие вас категории, отметив
                                  их галочкой. Завершив выбор, нажмите кнопку <b>Поиск</b>.</span>
                                `,
        'sub-heading-3': 'Настройка параметров',
        'sub-heading-3-para': `<span>Чтобы настроить параметры поиска для последующего использования, нажмите
                              пункт меню <b>Настройки</b> в верхней части страницы. В пункте
                              Языки поиска отметьте галочками необходимые вам языки поиска. В пункте
                              <b>Языки результата </b>выберите все языки, на которых вы хотите получать
                              результаты. В пункте <b>Разделы данных </b>выберите те разделы, по которым вы
                              хотите вести поиск. Настроив все необходимые параметры, нажмите кнопку
                              <b>Обновить настройки по умолчанию</b>, чтобы сохранить настройки.</span>
                            `,
        'sub-heading-4': 'Просмотр и сортировка результатов',
        'sub-heading-4-para-1': `<span>После нажатия кнопки поиска в верхней части страницы с результатами поиска
                                  будет отображена следующая информация: поисковый запрос, разделы, в которых
                                  были найдены результаты, и количество вхождений. Открыть карточку в отдельной
                                  вкладке можно, нажав кнопку <b>Открыть</b>, в то время как просмотреть
                                  краткое описание записи, не покидая результатов поиска, можно, нажав кнопку
                                  <b>Подробнее</b>.</span>
                                `,
        'para-4-footer-para-1': `<span>В левой части страницы результатов вы найдете меню <b>Фильтры</b>, которое
                                  позволяет отсортировать результаты по разделу, органу или теме. Отсортируйте
                                  результаты, отметив галочками интересующие категории, а для того, чтобы
                                  вернуться к полному отображению результатов, нажмите на кнопку
                                  <b>Сброс фильтров</b>. Чтобы закрыть фильтр, нажмите на <b>X</b> в верхней
                                  части.</span>
                                `,
        'sub-heading-5': 'Предложения изменений к карточкам и ссылки на них',
        'sub-heading-5-para-1': `<span>Предложить внести изменение в существующую карточку или дополнить ее можно,
                      открыв карточку и нажав кнопку <b>Отправить комментарии</b>. Откроется
                      всплывающее окно. Выберите язык предлагаемых изменений или дополнений и
                      заполните поля формы, после чего нажмите кнопку <b>Отправить</b>.<b></b
                    ></span>`,
        'sub-heading-5-footer-para-1': `<span>Если поиск не дал результатов, то внизу страницы появится пиктограмма в виде
                              конверта, на которую можно нажать, чтобы отправить предложение о создании
                              новой карточки. Откроется новая вкладка. Заполните форму и нажмите кнопку
                              <b>Отправить</b>.</span>
                            `,
        'sub-heading-5-footer-para-2': `<span>Если вы хотите поделиться с кем-то карточкой, нажмите на кнопку с
                                          пиктограммой «<b>Поделиться ссылкой»</b>: будет создано электронное письмо с
                                          термином и ссылкой на эту карточку.></span>
                                        `,
        'sub-heading-6': 'Доступ к ресурсам',
        'sub-heading-6-para-1': `<span>Во вкладке <b>Ресурсы</b> вы найдете полный список официальных названий
                                  стран, а также возможность скачать этот список в формате электронной
                                  таблицы.</span>
                                `,
        'sub-heading-7': 'Сообщить о технической проблеме',
        'sub-heading-7-para-1': `<span>При возникновении технической проблемы перейдите в раздел <b>Помощь</b> и
                                  выберите <b>Контакты</b>. Заполните форму с подробной информацией о проблеме и
                                  нажмите кнопку <b>Отправить</b>.</span>
                                `,
        'one': 'I',
        'two': 'II',
        'three': 'III',
        'four': 'IV',
        'five': 'V',
        'six': 'VI',
        'seven': 'VII',

    },

    zh: {
        'main-heading': 'UNTERM用户指南',
        'sub-heading-1': ' 搜索术语',
        'sub-heading-1-para-1': '要搜索术语，请在搜索框中输入搜索内容，点击<b>搜索</b>或按<b>回车键</b>。可使用右侧下拉菜单修改<b>搜索类型</b>，选择下列选项之一：',
        'sub-heading-1-para-point-1': `
                        <span  >搜索全部字词</span
                        ><span  >：这是默认的搜索选项，使用搜索的全部字词与术语条目进行匹配。当找到全部字词时，无论字词出现顺序如何，都将返回结果。例如，如果搜索</span
                        ><span  >“Rights Human”</span
                        ><span  >，会返回包含</span
                        ><span>
                          “Rights Human”</span
                        ><span  >和</span
                        ><span  >“Human Rights”</span
                        ><span>的结果。</span>`,
        'sub-heading-1-para-point-2': `精确匹配搜索：此搜索选项使用搜索查询条件进行精确匹配。例如，如果搜索"human rights"，会找到“human rights”，但不会找到“rights human”或“human right”。`,
        'sub-heading-1-para-point-3': `模糊搜索：此搜索把近似匹配项添加到搜索结果中。例如，如果搜索“dveelopment”，会找到“development”。`,
        'sub-heading-1-para-2': `在搜索全部字词和模糊搜索中，支持使用星号来替换任意数量的字符。例如：`,
        'sub-heading-1-para-2-point-1': `搜索“f*th”会找到包含“fourth”或“fifth”的结果。`,
        'sub-heading-1-para-2-point-2': `搜索“Task force on*”会找到以Task force on开头、后接任何文本的结果。`,
        'para-1-img-alt': `搜索菜单，其中包含各种搜索选项`,
        'para-1-img-q-tip': `提示：可使用快捷键Alt+s回到搜索框。`,
        'sub-heading-2': '使用高级搜索',
        'sub-heading-2-para-1': '在高级搜索选项下，可使用以下菜单进行自定义搜索和缩小搜索结果的范围：',
        'sub-heading-2-para-1-point-1': `选择搜索范围：选择要搜索的语言。用户在搜索框中输入的文本将用于搜索所选语言中的类似文本。默认情况下包括所有语言。`,
        'sub-heading-2-para-1-point-2': `选择显示范围：选择要以哪些语言显示搜索结果。`,
        'sub-heading-2-para-1-point-3': `数据库：选择要在来自哪些实体的词条集中进行搜索。默认情况下，所有数据库都包含在搜索结果中。`,
        'sub-heading-2-para-1-point-4': `机构：使用这一选项，可查看与特定机构有关的词条结果。默认情况下，所有机构都包含在搜索结果中。`,
        'sub-heading-2-para-1-point-5': `主题：使用这一选项，可查看与特定主题有关的词条结果。默认情况下，所有主题都包含在搜索结果中。`,
        'sub-heading-2-para-2': `要查找某个数据库、机构或主题，请使用下拉菜单查看列表，或点击菜单并输入感兴趣的内容。例如，输入“人”，会显示所有包含“人”字的主题。勾选右侧复选框，选择感兴趣的条目。选择完毕后点击“搜索”。`,
        'para-2-img-alt': `高级搜索菜单，其中显示语言、数据集、主题和机构下拉菜单。`,
        'sub-heading-3': '调整设置',
        'sub-heading-3-para': `<span >要为将来的搜索调整设置，请前往页面顶部，点击<b>设置</b>。在<b>选择搜索范围</b>下，勾选首选搜索语言对应的复选框。在<b>选择显示范围</b>下，点击要在搜索结果中显示的所有语言。在<b>数据库</b>下选择要搜索的数据集。选择完毕后点击<b>更新默认设置</b>，保存所选内容。</span>`,
        'para-3-img-alt': `“设置”标签页的选项`,
        'sub-heading-4': '查看和优化结果',
        'sub-heading-4-para-1': `<span>启动搜索后，搜索结果上方将显示搜索内容、术语所在数据库以及搜索结果的数量。单击<b>打开</b>，可在单独的标签页中查看词条，或点击<b>详细信息</b>，在搜索结果中查看词条概要。</span>`,
        'para-4-img-alt': `显示搜索结果`,
        'para-4-footer-para-1': `<span >搜索结果页面左侧有<b>筛选</b>菜单，可按<b>数据库</b>、<b>机构</b>或<b>主题</b>缩小搜索结果的范围。勾选复选框可缩小结果范围，点击<b>全部清除</b>可重新显示全部结果。要关闭筛选菜单，请点击顶部的 <b>X</b></span>`,
        'para-4-img-alt-2': `打开筛选菜单`,
        'sub-heading-5': '提出反馈和分享词条',
        'sub-heading-5-para-1': `要对现有词条提出反馈，无论是建议修改还是添加内容，请打开词条，点击发送反馈。点击后会打开一个弹窗。选择希望提出反馈的语言，填写各栏，然后点击提交。`,
        'sub-heading-5-img-alt': `打开的词条页面中的发送反馈按钮`,
        'sub-heading-5-footer-para-1': `<span>如果搜索没有返回结果，页面底部会显示信封图标，可点击该图标提交新词条建议。点击后会打开一个新标签页。填写表格，点击<b>提交</b>。</span>`,
        'sub-heading-5-img-alt-2': `词条建议表格的链接`,
        'sub-heading-5-footer-para-2': `<span >如果想与他人分享词条，请点击<b>分享链接</b>按钮。点击后会生成一封包含当前术语和词条链接的电子邮件。</span>`,
        'sub-heading-5-img-alt-3': `打开的词条页面中的分享链接按钮`,
        'sub-heading-5-img-alt-4': `自动生成的包含词条链接的电子邮件`,
        'sub-heading-6': '查阅资源',
        'sub-heading-6-para-1': `<span >在<b>资源</b>标签下有正式<b>国名</b>列表，可选择以电子表格格式下载完整列表。</span>`,
        'sub-heading-7': '报告技术问题',
        'sub-heading-7-para-1': `<span >如果遇到技术问题，请点击<b>帮助</b>，选择<b>联系我们</b>。在表格中填写问题详情，点击<b>提交</b>。</span>`,
        'sub-heading-7-img-alt': `帮助菜单，其中包含联系我们子菜单`,
        'one': '一',
        'two': '二',
        'three': '三',
        'four': '四',
        'five': '五',
        'six': '六',
        'seven': '七',
    }
}
